import { Divider, Select } from '@sede-enterprise/shell-ds-react-framework';
import React, { useEffect, useState, useContext } from 'react'
import AssetStatistics from './AssetStatistics';
import UsageStatistics from './UsageStatistics';
import AdminView from './AdminView';
import useFetchRatings from './hooks/useFetchRatings';
import useFetchSites from './hooks/useFetchSites';
import { AuthContext } from '../../AuthProvider';
import { INT_USER_ROLES } from '../../util/constants';

const StatisticsScreen = () => {

    const { role } = useContext(AuthContext);
    const isIntUser = INT_USER_ROLES.includes(role);

    // Site Filter selected 
    const [selectedSites, setSelectedSites] = useState([]);

    // Fetch Site Options
    const { siteOptions, loading } = useFetchSites();
    //Select state of the dropdown
    const [siteSelection, setSiteSelection] = useState([])

    //Fetch Ratings Data
    const { data: ratingsData } = useFetchRatings()


    // Populate selectedSites with siteOptions on initial render
    useEffect(() => {
        if (siteOptions.length > 0) {
            setSelectedSites(siteOptions);
        }
    }, [siteOptions]);


    return (
        <>
            <div className='parent-container'>
                <div className='content-container'>
                    <div className='content-header'>
                        <h2>Usage Statistics</h2>
                        <div className='site-select-wrapper'>
                            <Select mode='multiple' placeholder='Select Site' options={siteOptions}
                                onChange={(_, option) => {
                                    setSiteSelection(option);
                                    if (option.length > 0) {
                                        setSelectedSites(option)
                                    }
                                    else {
                                        setSelectedSites(siteOptions)
                                    }
                                }}
                                onClear={() => setSelectedSites(siteOptions)}
                                value={siteSelection}
                                loading={loading}
                                disabled={loading}
                            />
                        </div>
                    </div>
                    <br />
                    <AssetStatistics selectedSite={selectedSites} />
                </div>
            </div>
            <br />
            <br />
            <Divider />
            <br />
            <br />
            <UsageStatistics selectedSite={selectedSites} />
            <br />
            <br />
            <Divider />

            {isIntUser && <AdminView ratingsData={ratingsData} />}
        </>
    )
}

export default StatisticsScreen